import React, { useState } from "react";
import { Row } from "react-bootstrap";
import {
  getPublicSymbolSize,
  getStyle,
  getAdjustedFontSize,
} from "../Common/StylesHelper";
import { hexToRgba } from "utils/Utils";
import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";
import productGridPlaceholder from "assets/images/productGridPlaceholder.png";
import PublicTagShape from "./PublicTagShape";
import DragScroll from "components/common/DragScroll";

const ProductPreview = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  currencyInfo,
  layoutSettings = {},
  language,
  layoutType,
  isApplyBlackColor,
  responsiveLayoutType,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectedProduct = products[selectedIndex];

  return (
    <div className="product-preview-wrapper">
      <Row>
        <ProductCard
          key={selectedProduct.productId}
          product={selectedProduct}
          config={config}
          layoutSettings={layoutSettings}
          styles={styles}
          index={selectedIndex}
          primaryColor={primaryColor}
          theme={theme}
          type="selectedItem"
          language={language}
          currencyInfo={currencyInfo}
          isApplyBlackColor={isApplyBlackColor}
          responsiveLayoutType={responsiveLayoutType}
        />
      </Row>

      <div className="d-flex overflow-auto pt-3 bottom_cards_list gap-2">
        {products?.map((product, index) => (
          <div
            key={product.productId}
            className={`mx-2`}
            onClick={() => setSelectedIndex(index)}
            style={{
              cursor: "pointer",
              width: "55%",
              // border:
              //   index === selectedIndex ? `1px solid ${primaryColor}` : "none",
            }}
          >
            <ProductCard
              product={product}
              config={config}
              layoutSettings={layoutSettings}
              styles={styles}
              index={index}
              primaryColor={primaryColor}
              theme={theme}
              type="all"
              isSelected={index === selectedIndex}
              language={language}
              currencyInfo={currencyInfo}
              isApplyBlackColor={isApplyBlackColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductPreview;

const ProductCard = ({
  product,
  config,
  styles,
  index,
  primaryColor,
  theme,
  type,
  layoutSettings,
  isSelected,
  language,
  currencyInfo,
  isApplyBlackColor,
  responsiveLayoutType,
}) => {

  const isAll = type === "all";

  const { allergenBackgroundColor } = theme || {};

  const {
    productTitle,
    productPrice,
    productCalorie,
    imageUrl,
    productDescription,
    allergens,
    addonsOptions = {},
  } = product;

  const priceAndSizes = [
    ...(addonsOptions?.priceAndSizes || []),
    ...(addonsOptions?.modifierOptions || []),
  ];

  const {
    showPreviewImage,
  } = config || {};

  const {
    applyConfigSettingsOnPreviewDetails,
    selectedItemStyle = {},
    imageCornerRadius,
  } = layoutSettings?.productPreview || {};

  const {
    borderWidth,
    backgroundColor,
    borderColor,
    backgroundColorOpacity,
  } = selectedItemStyle || {};

  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);

  const cardStyles = {
    borderRadius:"10px",
    border: `${borderWidth}px solid ${borderColor}`,
    backgroundColor: hexToRgba(backgroundColor, backgroundColorOpacity),
  };

  const shouldShow = (key) => {
    return type === "selectedItem"
      ? !applyConfigSettingsOnPreviewDetails || config?.[key]
      : config?.[key];
  };

  return (
    <div className="product-card product_preview" style={isAll && isSelected ? cardStyles : {}}>
      <div className="fist_card">
        {shouldShow("showTags") && product?.tags && (
          <PublicTagShape
            shape={product?.tags?.id}
            color={product?.tags?.color || "#A47E51"}
            name={product?.tags?.label}
            styles={styles}
            width={60}
            height={60}
            wrapperClass="common_shape_tag "
          />
        )}

        <img
          src={imageUrl || productGridPlaceholder}
          alt={productTitle}
          className="product-image"
          style={{
            visibility:
              type === "selectedItem"
                ? !applyConfigSettingsOnPreviewDetails
                  ? "visible"
                  : showPreviewImage
                    ? "visible"
                    : "hidden"
                : type === "all"
                  ? showPreviewImage
                    ? "visible"
                    : "hidden"
                  : "hidden",
            borderRadius: imageCornerRadius,
          }}
        />

        <div className="g_between gap-2 titles">
          {shouldShow("showTitle") && (
            <h5
              className={`product-title ${isAll ? "in_one_line" : ""}`}
              style={{
                ...getStyle(styles, "productTitle"),
                ...(isApplyBlackColor && { color: "#000" }),
                fontSize: getAdjustedFontSize(14, styles?.productTitle?.family),
              }}
            >
              {productTitle}
            </h5>
          )}

          {shouldShow("showPrice") && (
            <p
              className="product-price ltr d-flex"
              style={{
                ...getStyle(styles, "productPrice"),
                ...(isApplyBlackColor && { color: "#000" }),
              }}
            >
              {/* <CurrencySymbol
                color={styles["productPrice"].color || primaryColor}
                width={width}
                height={height}
              />
              <span>{productPrice}</span> */}
              <PublicPreviewPriceDisplay
                currencyInfo={currencyInfo}
                productPrice={productPrice}
                width={12}
                height={12}
                primaryColor={
                  isApplyBlackColor
                    ? "#000"
                    : styles["productPrice"].color || primaryColor
                }
                extraSpanStyles={{
                  fontSize: getAdjustedFontSize(14, styles?.productPrice?.family),
                }}
              />
            </p>
          )}
        </div>

        <div className="g_between mt-1">
          <div className="allergens allergens_div">
            {allergens?.length > 0 && shouldShow("showAllergens") && (
              <>
                {/* <h5
                  style={getThemeFontStyles(theme)}
                >
                  {getAllergenText(language)}
                </h5> */}
                <div
                  className="inner_section allergen_inner productGrid2_allergen pb-0"
                  style={{ maxWidth: isAll ? 60 : "auto" }}
                >
                  {allergens?.map((allergen, i) => (
                    <div
                      key={i}
                      className="inner_div"
                      style={{
                        "--theme-primary-color": allergenBackgroundColor,
                      }}
                    >
                      <img src={allergen?.url} width={15} height={15} alt="" />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          {shouldShow("showCalorie") && (
            <p
              className="w_fit_content"
              style={{
                ...getStyle(styles, "productCalorie"),
                ...(isApplyBlackColor && { color: "#000" }),
                fontSize: getAdjustedFontSize(10, styles?.productCalorie?.family),
              }}
            >
              {productCalorie}
            </p>
          )}
        </div>
        <div className="addon_prices_wrapper">
          {priceAndSizes.length > 0 && (
            <div className="price-and-sizes-container">
              <DragScroll className="inner_section">
                {priceAndSizes.map((sizeOption) => (
                  <div
                    key={sizeOption.id}
                    className="size-price-item"
                    style={{
                      borderColor:
                        { ...getStyle(styles, "productTitle") } || "#fff",
                    }}
                  >
                    <span
                      className="size-name"
                      title={sizeOption.name}
                      style={{
                        ...getStyle(styles, "productTitle"),
                        ...(isApplyBlackColor && { color: "#000" }),
                        whiteSpace: "nowrap",
                        fontSize: getAdjustedFontSize(
                          8,
                          styles?.productTitle?.family
                        ),
                      }}
                    >
                      {sizeOption.name}
                    </span>
                    <span
                      className="size-price ltr w_fit_content"
                      title={`${sizeOption.price}`}
                      style={{
                        ...getStyle(styles, "productTitle"),
                        fontSize: getAdjustedFontSize(
                          8,
                          styles?.productTitle?.family
                        ),
                      }}
                    >
                      <PublicPreviewPriceDisplay
                        currencyInfo={currencyInfo}
                        productPrice={sizeOption.price}
                        width={10}
                        height={10}
                        primaryColor={
                          isApplyBlackColor
                            ? "#000"
                            : styles["productTitle"]?.color || primaryColor
                        }
                        extraSpanStyles={{
                          fontSize: getAdjustedFontSize(
                            12,
                            styles?.productTitle?.family
                          ),
                        }}
                      />
                    </span>
                  </div>
                ))}
              </DragScroll>
            </div>
          )}
        </div>

        {shouldShow("showDescription") && type === "selectedItem" && (
          <p
            className="product-description"
            style={{
              ...getStyle(styles, "productDescription"),
              ...(isApplyBlackColor && { color: "#000" }),
              fontSize: getAdjustedFontSize(12, styles?.productDescription?.family),
            }}
          >
            {productDescription}
          </p>
        )}
      </div>
    </div>
  );
};

